<template>
    <page-content>

      <a-input-search
          placeholder="请输入监控直播地址"
          enter-button="保存"
          size="large"
          v-model="camera.link"
          :disabled="loading || saving"
          @search="onSave"
      />

        <d-player
          v-if="camera.link"
          :key="camera.link"
          class="player"
          :options="options"
          ref="player"
        ></d-player>
    </page-content>
</template>
<script>

    import VueDPlayer from 'vue-dplayer'
    import 'vue-dplayer/dist/vue-dplayer.css'

    export default {
        components: {
            'd-player': VueDPlayer,
        },
        data() {
            return {
              deviceId: this.$route.params.deviceId,
              loading: false,
              saving: false,
                camera: {
                    id: "",
                    link: "",
                },
            }
        },
        computed: {
            playerOptions() {
                return {
                    height: '800',
                    sources: [{
                        type: 'application/x-mpegURL',
                        src: this.camera.link
                        // type:'video/mp4',
                        // src:""
                    }],
                    // techOrder: ['flash'],
                    autoplay: true,
                    controls: false,
                    // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-9.jpg'
                }
            },
            options() {
                return {
                    video: {
                        url: this.camera.link,
                        type: 'flv'
                    }
                }
            }
        },

        created() {
            this.fetchCamera()
        },
        methods: {
          fetchCamera() {
            if (!this.deviceId) {
              return
            }
            this.loading = true
            this.$get(`web/camera/device/${this.deviceId}`, {}).then(r => {
              this.camera = r.data || {}
              if (!this.camera.link) {
                this.camera.link = ""
              }
            }).finally(() => {
              this.loading = false
            })
          },
          onSave() {
            if (!this.deviceId) {
              return
            }
            this.saving = true
            this.$put(`web/camera/device/${this.deviceId}/link`, { link: this.camera.link }).then(r => {
              if (r && r.data) {
                this.camera = r.data
                if (!this.camera.link) {
                  this.camera.link = ""
                }
              }
              this.$message.success("保存成功")
            }).finally(() => {
              this.saving = false
            })
          }
        }

    }
</script>
<style lang="less" scoped>
.player{
    border-radius: 5px;
    overflow: hidden;
    margin-top: 20px;
}
</style>
